import { render, staticRenderFns } from "./BacBigButton.vue?vue&type=template&id=57aeead4&scoped=true&"
import script from "./BacBigButton.vue?vue&type=script&lang=ts&"
export * from "./BacBigButton.vue?vue&type=script&lang=ts&"
import style0 from "./BacBigButton.vue?vue&type=style&index=0&id=57aeead4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aeead4",
  null
  
)

export default component.exports